'use strict';

import raven from 'raven';
import SimpleMessages from '../../controllers/simple-messages';
import ngAsync from 'app/async/async.function.decorator';

class ReceiptsController {
  /* @ngInject */
  constructor(
    ReceiptsService,
    ClientsService,
    EmployeesService,
    VehiclesService,
    OrderTranslationService,
    $scope,
    $stateParams,
    $q,
    $filter,
    focus,
    $mdToast,
    $mdDialog
  ) {
    Object.assign(this, {
      ReceiptsService,
      ClientsService,
      EmployeesService,
      VehiclesService,
      OrderTranslationService,
      $scope,
      $stateParams,
      $q,
      $filter,
      focus,
      $mdToast,
      $mdDialog
    });

    this.query = {
      include: [
        'client',
        'collection',
        'employee',
        {
          relation: 'quotes',
          scope: {
            include: 'vehicle'
          }
        },
        {
          relation: 'paymentItems',
          scope: {
            include: ['bankTx', 'check']
          }
        }
      ],
      where: {},
      limit: 25,
      page: 1,
      order: 'date DESC',
      deleted: true
    };

    if (this.$stateParams.quoteId) {
      let quoteId = parseInt(this.$stateParams.quoteId, 10);
      if (!isNaN(quoteId)) {
        this.quoteId = quoteId;
      }
    }

    this.getReceipts();

    this.onPagination = () => {
      this.getReceipts();
    };

    this.onReorder = () => {
      this.getReceipts();
    };
  }

  onClientFilterUpdate($event) {
    let clientsPromise = $event.clientsPromise;
    clientsPromise.then(clients => {
      this.clientIds = clients ? clients.map(c => c.id) : null;
      this.getReceipts();
    });
  }

  $onInit() {}

  getReceipts() {
    let qOpts = JSON.parse(JSON.stringify(this.query));

    if (this.id) {
      this.quoteId = null;
      this.clientIds = null;
      (this.employee = null), (this.vehicle = null);
      this.onlyNotCollected = false;
      this.onlyInvoiceable = false;

      qOpts.where = Object.assign(qOpts.where, {
        id: this.id
      });
    }

    if (this.quoteId) {
      // FIXME: won't be affected by mdOrder
      let queryReady = this.ReceiptsService.getReceiptsForQuote(
        this.quoteId,
        qOpts
      ).then(receipts => {
        this.receipts = receipts;
      });
      let countReady = this.ReceiptsService.countReceiptsForQuote(
        this.quoteId,
        qOpts
      ).then(result => {
        this.receiptsCount = result.count;
      });
      this.promise = this.$q.all([queryReady, countReady]);
      return this.promise;
    }

    if (this.clientIds) {
      qOpts.where = Object.assign(qOpts.where, {
        clientId: {
          inq: this.clientIds
        }
      });
    }
    if (this.employee) {
      qOpts.where = Object.assign(qOpts.where, {
        employeeId: this.employee.id
      });
    }
    if (this.vehicle) {
      Object.assign(qOpts.where, {
        vehicleId: this.vehicle.id
      });
    }
    if (this.onlyNotCollected) {
      qOpts.where = Object.assign(qOpts.where, {
        isCollected: false
      });
    }
    if (this.onlyInvoiceable) {
      qOpts.where = Object.assign(qOpts.where, {
        isInvoiceable: true
      });
    }
    if (this.mdOrder) {
      qOpts.order = this.OrderTranslationService.translate(this.mdOrder);
    }

    let queryReady = this.ReceiptsService.getModels(qOpts).then(receipts => {
      let total = 0;
      receipts.forEach(r => {
        r.vehicles = r.quotes
          .map(
            q => q.vehicle.plate || q.vehicle.number || q.vehicle.description
          )
          .join(', ');

        if (!r.deletedAt) {
          total += r.amount;
        }

        r.paymentDataSummary = r.paymentItems
          .map(pi => this.getLabelPaymentItemType(pi))
          .join(', ');
        let paymentData = {};
        r.paymentItems.forEach(pi => {
          let type = this.getLabelPaymentItemType(pi);
          if (!paymentData[type]) paymentData[type] = 0;
          paymentData[type] += pi.amount;
        });

        r.paymentDataTooltip = Object.keys(paymentData)
          .map(
            type => `${type}: ${this.$filter('formatMoney')(paymentData[type])}`
          )
          .join(', ');
      });
      this.receipts = receipts;
      this.total = total;
    });

    // Hacky count opts so that deleted are included
    let countOpts = JSON.parse(JSON.stringify(qOpts));
    countOpts.where.deleted = true;
    let countReady = this.ReceiptsService.getCount(countOpts).then(result => {
      this.receiptsCount = result.count;
    });
    this.promise = this.$q.all([queryReady, countReady]);
    return this.promise;
  }

  /* eslint-disable indent,no-unreachable */
  getLabelPaymentItemType(paymentItem) {
    switch (paymentItem.type) {
      case 'cash':
        return 'EF';
        break;
      case 'bankTx':
        return 'TR';
        break;
      case 'check':
        return 'CH';
        break;
    }
  }
  /* eslint-enable */

  querySearchClient() {
    return this.ClientsService.findByName(this.searchTextClient);
  }

  queryEmployeeSearch() {
    return this.EmployeesService.find({
      filter: {
        where: {
          name: {
            regexp: `^${this.searchEmployeeText}/i`
          }
        }
      }
    });
  }

  queryVehicleSearch() {
    return this.VehiclesService.getModels({
      where: {
        broad: this.searchVehicleText
      },
      order: 'plate DESC, number DESC, description DESC'
    }).then(vehicles => {
      return vehicles.map(v => {
        v.fullDesc = `${v.plate} - ${v.number} - ${v.description}`;
        return v;
      });
    });
  }

  editInvoice(receipt) {
    receipt.editing = true;
    this.focus.focusOn('focusMe');
  }

  @ngAsync()
  async doneEditingInvoice(receipt) {
    let invoiceNumber = parseInt(receipt.invoiceNumber);
    if (receipt.invoiceNumber && isNaN(invoiceNumber)) return;

    // If user erased invoice number, use 0 to delete it
    invoiceNumber = !receipt.invoiceNumber ? 0 : invoiceNumber;
    receipt.editing = false;

    const invoiceExists =
      invoiceNumber &&
      (await this.ReceiptsService.find({
        filter: {
          where: {
            invoiceNumber: invoiceNumber
          },
          order: 'id ASC'
        }
      }));
    let doIt = true;
    if (invoiceExists && invoiceExists.length) {
      const confirmDialog = this.$mdDialog
        .confirm()
        .title('Factura ya utilizada')
        .textContent(
          `Los siguientes recibos ya tienen el mismo \
número de factura: ${invoiceExists.map(r => r.id).join(', ')}`
        )
        .ok(`Aceptar`)
        .cancel('Cancelar');

      try {
        await this.$mdDialog.show(confirmDialog);
      } catch (e) {
        doIt = false;
      }
    }
    if (doIt) {
      try {
        await this.ReceiptsService.updateInvoiceNumber({
          id: receipt.id,
          invoiceNumber: invoiceNumber
        });
        this.simpleSuccess();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        raven.captureException(e);
        this.simpleError();
      }
    } else {
      receipt.invoiceNumber = null;
    }
  }
}

Object.assign(ReceiptsController.prototype, SimpleMessages);
export default ReceiptsController;
